(function (globalScope) {
  // Each active Shopify variant uses its own Kaching fixed-price plan so the
  // recurring checkout price exactly matches the storefront price.
  var SELLING_PLAN_IDS = {
    buy1: 1997635659,
    buy2Get1: 1997602891,
    buy3Get2: 1997668427
  };
  var FALLBACK_VARIANTS = {
    buy1: 42630181421131,
    buy2Get1: 42630181453899,
    buy3Get2: 42630181486667
  };
  var GIFT_VARIANTS = {
    sleepGuide: 43029410447435,
    sleepMask: 43029419622475
  };
  var VARIANT_TITLES = {
    buy1: ['Buy 1'],
    buy2Get1: ['Buy 2 Get 1 Free'],
    buy3Get2: ['Buy 3 Get 2 Free']
  };

  var bundleAliases = {
    buy1: 'buy1',
    buy2Get1: 'buy2Get1',
    buy2get1free: 'buy2Get1',
    buy1Get1: 'buy2Get1',
    buy1get1free: 'buy2Get1',
    buy3Get2: 'buy3Get2',
    buy3get2free: 'buy3Get2',
    buy2Get2: 'buy3Get2',
    buy2get2free: 'buy3Get2'
  };

  function normalizePurchaseType(purchaseType) {
    return purchaseType === 'subscription' ? 'subscription' : 'oneTime';
  }

  function findVariant(titles) {
    var catalog = globalScope && Array.isArray(globalScope.LullaBitesVariantCatalog)
      ? globalScope.LullaBitesVariantCatalog
      : [];
    var normalizedTitles = titles.map(function (title) {
      return String(title).trim().toLowerCase();
    });
    var match = catalog.find(function (variant) {
      return normalizedTitles.indexOf(String(variant.title || '').trim().toLowerCase()) !== -1;
    });

    return match || null;
  }

  function resolveCartItem(purchaseType, bundleKey) {
    var normalizedPurchaseType = normalizePurchaseType(purchaseType);
    var normalizedBundleKey = bundleAliases[bundleKey] || 'buy1';
    // One-time and subscription purchases intentionally use the SAME three
    // active Shopify variants. A subscription differs only by selling_plan.
    var variant = findVariant(VARIANT_TITLES[normalizedBundleKey]);
    var variantId = variant ? Number(variant.id) : FALLBACK_VARIANTS[normalizedBundleKey];

    if (!variantId) {
      throw new Error('The Shopify variant for this bundle was not found.');
    }

    var item = { id: variantId, quantity: 1 };

    if (normalizedPurchaseType === 'subscription') {
      item.selling_plan = SELLING_PLAN_IDS[normalizedBundleKey];
    }

    return item;
  }

  function resolveCartItems(purchaseType, bundleKey) {
    var normalizedPurchaseType = normalizePurchaseType(purchaseType);
    var normalizedBundleKey = bundleAliases[bundleKey] || 'buy1';
    var items = [resolveCartItem(normalizedPurchaseType, normalizedBundleKey)];

    if (
      normalizedPurchaseType === 'subscription' &&
      (normalizedBundleKey === 'buy2Get1' || normalizedBundleKey === 'buy3Get2')
    ) {
      items.push(
        { id: GIFT_VARIANTS.sleepGuide, quantity: 1 },
        { id: GIFT_VARIANTS.sleepMask, quantity: 1 }
      );
    }

    return items;
  }

  function resolveCheckoutUrl(purchaseType, bundleKey) {
    var item = resolveCartItem(purchaseType, bundleKey);
    var url = '/cart/' + item.id + ':1';

    return item.selling_plan ? url + '?selling_plan=' + item.selling_plan : url;
  }

  var api = {
    SELLING_PLAN_IDS: SELLING_PLAN_IDS,
    GIFT_VARIANTS: GIFT_VARIANTS,
    resolveCartItem: resolveCartItem,
    resolveCartItems: resolveCartItems,
    resolveCheckoutUrl: resolveCheckoutUrl
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (globalScope) {
    globalScope.LulabitesCheckoutRoutes = api;
    globalScope.LullaBitesCheckoutRoutes = api;
  }
})(typeof window !== 'undefined' ? window : globalThis);
